<template>
<div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">      
    

    <div class="btn-group btn-group-lg">
      <button  @click="emit('customers')"  data-toggle="tooltip" title="Ricerca cliente"  type="button" class="btn btn-info border border-secondary  rounded-lg">
            <i class="fas fa-users" aria-hidden="true"></i>
        </button>
      <button   @click="emit('productSearch')" data-toggle="tooltip" title="Ricerca prodotto"  type="button" class="btn btn-success border border-secondary rounded-lg">
        <i class="fas fa-binoculars" aria-hidden="true"></i>
      </button>
      <button  @click="emit('cartDiscount')" 
        data-toggle="tooltip" title="Applica sconto"
        type="button" class="btn btn-custom5 border border-secondary rounded-lg">
        <i class="fas fa-percentage mr-2" aria-hidden="true"></i>
      </button>

      <button @click="emit('lastSale')" 
        data-toggle="tooltip" title="Ultima vendita"
        type="button" class="btn btn-custom1 border border-secondary rounded-lg">
        <i class="fas fa-shopping-bag " aria-hidden="true"></i>
      </button>



      <button @click="emit('resetCart')" type="button"  data-toggle="tooltip" title="Reset carrello" class="btn btn-custom2 
      border border-secondary
      rounded-lg ">    
        <i class="material-icons" >remove_shopping_cart</i>        
      </button>    

      <button v-if="company.stores.length > 1"  @click="emit('storeMovement')"  
        data-toggle="tooltip" title="Trasferimento altra sede"  
        type="button" class="btn btn-custom8  border border-secondary rounded-lg brown">
        <i class="fas fa-dolly " aria-hidden="true"></i>
      </button>


    </div>  

    <div class="btn-group btn-group-lg " role="group" aria-label="Second group">
      <button   @click="emit('saveCartToSession')" 
        data-toggle="tooltip" title="Sospendi carrello"
        class="btn btn-custom3 border border-secondary rounded-lg  ">
        <i  class="far fa-copy " aria-hidden="true"></i>
      </button>
      <button   @click="emit('getCartFromSession')" 
        data-toggle="tooltip" title="Riprendi carrello"
        class="btn btn-custom4 border border-secondary  rounded-lg ">
        <i  class="fas fa-paste " aria-hidden="true"></i>
      </button>
    </div>
    <button @click="emit('coupon')" type="button"  data-toggle="tooltip" title="Coupon" class="btn btn-custom7 border border-secondary rounded-lg ">            
        <i class="material-icons" >card_giftcard</i>
    </button>  
    <!--
    <button  @click="emit('customerPayment')" type="button"  data-toggle="tooltip" title="Salda e ritira" class="btn btn-custom9 border border-secondary rounded-lg ">            
        <i class="material-icons" >account_balance_wallet</i>
    </button>  
    -->
  
    <!-- Example single danger button -->
  <div  v-if="company.Id == 26" class="btn-group ml-3 border border-danger">
    <button type="button" class="btn btn-light dropdown-toggle gc" data-toggle="dropdown" aria-expanded="false">
      GIFT CARD
    </button>
  <div class="dropdown-menu">
    <a @click="emit('GiftCardCreate')" class="dropdown-item" href="#">Registrazione nuova gift card</a>
    <a @click="emit('GiftCardPrintBarcode')" class="dropdown-item" href="#">Stampa etichetta gift card</a>
    <a @click="emit('GiftCardValidate')"class="dropdown-item" href="#">Controllo gift card</a>

      
  </div>
</div>

    

  
    
   

  <!-- ToolBar -->
  </div>

</template>
<script>
import { mapGetters }     from 'vuex'
export default {

  computed: 
  {
    ...mapGetters(['storeId','company']) , 
  }, 
  
  methods: 
  {
    emit(type)
    {
      this.$emit('update',type)
    },
   
  } 
}
</script>

<style scoped>




.material-icons{
  font-size: 25px;
}


.btn:not(.gc):hover {
  
  background-color   : white;
    
  border-color       : red !important;
  border-left-width  : 10px !important;
  border-right-width : 10px !important;
  
  /*
  margin-left        : 1px;
  margin-right       : 1px;
  */
  
  
  
}



.btn-custom1{
 
  background-color:#ec7211;
}
.btn-custom2{
 
  background-color:#FFFF00;
}
.btn-custom3{
 
  background-color:rgb(8, 183, 246);
}
.btn-custom4{
 
  background-color:rgb(82, 126, 109);
}
.btn-custom5{
 
  background-color: #66CC99;
}
.btn-custom6{
 
  background-color: #3399FF;
}
.btn-custom7
{

  background-color: blueviolet;
}
.btn-custom9
{

  background-color: crimson;
}
.btn-custom8
{
  background-color: rgb(175, 154, 32);
}

.fas{
  color :rgb(0, 0, 0)
}
.far{
  color:black
}
.material-icons{
  color : black
}
.rounded-lg
{
  width: 120px;
}


</style>